import Form from '../_form';

export default class NotificationsSettingsForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const sections = this.form.querySelectorAll('.notifications-form--dropdown-section');
        if (!sections || !sections.length) return;

        this.sections = [...sections];

        this.setup();
    }

    setup () {
        const checkbox = document.querySelector('input#notifications');
        if (!checkbox) return;

        const dropdowns = document.querySelectorAll('.notifications-form--dropdown');
        if (!dropdowns || !dropdowns.length) return;

        const disable = () => {
            if (!checkbox.checked) {
                [...dropdowns].forEach((dropdown) => {
                    const inner = dropdown.querySelector('.notifications-form--dropdown-content');

                    dropdown.classList.remove('collapsed');
                    dropdown.classList.add('disabled');

                    inner.removeAttribute('style');
                });
            } else {
                [...dropdowns].forEach((dropdown) => {
                    dropdown.classList.remove('disabled');
                });
            }
        }

        disable();
        checkbox.addEventListener('change', disable);
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const notifications = formData.get('notifications');

        const projects = formData.get('notifications_projects');
        const projectsEmail = formData.get('notifications_projects_email');

        const jobs = formData.get('notifications_jobs');
        const jobsEmail = formData.get('notifications_jobs_email');

        try {
            await fetch('/wp-json/user/v1/notifications-settings', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    notifications, projects, projectsEmail, jobs, jobsEmail
                })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully updated!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
